import ApiClient from './ApiClient';

const {
  TRANSCRIPTION_SECRET: transcriptionSecret,
  TRANSCRIPTION_TOKEN: transcriptionToken,
} = window.globalConfig || {};

class TranscriptionApi extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  async getTranscription({ fileUrl, name }) {
    const payload = {
      file_url: fileUrl,
      model: 'whisper-1',
      secret: transcriptionSecret,
      token: transcriptionToken,
      account_name: name,
    };
    const res = await axios.post(`${this.url}transcription`, payload);

    const text = JSON.parse(res.data.body);

    return { data: text };
  }
}

export default new TranscriptionApi();
